import { render } from "./BasePaginationTrigger.vue?vue&type=template&id=5bb3157a&scoped=true"
import script from "./BasePaginationTrigger.vue?vue&type=script&lang=js"
export * from "./BasePaginationTrigger.vue?vue&type=script&lang=js"

import "./BasePaginationTrigger.vue?vue&type=style&index=0&id=5bb3157a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3157a"]])

export default __exports__